export const snapLikeApiPath = {
  /** 좋아요 한 스냅 존재 여부 카운트 포함 조회 */
  getLikedSnapsCount: '/api2/content/snap/v1/profiles/liked-snaps/count',
  /** 스냅 좋아요 (POST) / 좋아요 취소 (DELETE) */
  snapLiked: (snapId: string) => `/api2/content/snap/v1/snaps/${snapId}/liked`,
} as const;
